module.exports = __webpack_public_path__ + "assets/8d4e92b8801e134cdab80f0aa7b42082.svg";